import { createContext } from 'react';

const HideFooterContext = createContext();

export default HideFooterContext;
